
import React from 'react';

interface TimelineItemProps {
  year: string;
  title: string;
  description: string;
  position: 'left' | 'right';
  icon: React.ReactNode;
}

const TimelineItem = ({ 
  year, 
  title, 
  description, 
  position, 
  icon 
}: TimelineItemProps) => {
  return (
    <div className={`timeline-item relative flex items-center opacity-1 transform translate-y-0 transition-all duration-500 ${position === 'right' ? 'flex-row' : 'flex-row-reverse'}`}>
      {/* Content */}
      <div className={`w-5/12 ${position === 'right' ? 'text-right pr-8' : 'text-left pl-8'}`}>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-border/50 hover:border-primary/50 transition-colors duration-300">
          <span className="text-sm font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">{year}</span>
          <h4 className="text-xl font-bold mt-2 mb-2">{title}</h4>
          <p className="text-muted-foreground">{description}</p>
        </div>
      </div>
      
      {/* Center dot */}
      <div className="absolute left-1/2 transform -translate-x-1/2 w-10 h-10 rounded-full bg-white border-4 border-primary flex items-center justify-center z-10">
        {icon}
      </div>
      
      {/* Empty space for the other side */}
      <div className="w-5/12"></div>
    </div>
  );
};

export default TimelineItem;
